import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { isPermissionFull } from '@/features/login/util/permission';
import { validateRoute } from '@/router/util';

// biome-ignore assist/source/useSortedKeys: the property order of the passed in object matters due to type inference
export const Route = createFileRoute('/a/cobranca-cartao')({
    validateSearch: z.object({ idpk: z.string().optional() }),
    beforeLoad: () =>
        validateRoute({
            fintech: true,
            validatePermission: ({ upp_financeiro_cartao }) =>
                isPermissionFull(upp_financeiro_cartao),
        }),
});
